"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Wikipedia standard mail syntax:
// https://en.wikipedia.org/wiki/Email_address#Examples
function validateEmail(email) {
    var regex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>().,;\s@"]+\.{0,1})+([^<>().,;:\s@"]{2,}|[\d.]+))$/;
    return regex.test(email);
}
exports.default = validateEmail;
